import { Icon } from '@bosch/react-frok'
import { BadgeConfig, BadgeProps } from './types'

import './Badge.scss'
import { t } from 'i18next'

const Badge = (props: BadgeProps) => {
    const { badges, mode, position } = props

    const badgeConfig: BadgeConfig = {
        beta: {
            labelDesktop: t('home:badge:betaVersion'),
            labelMobile: t('home:badge:beta'),
            className: "beta",
            icon: "flask"
        },
        devSandbox: {
            labelDesktop: 'Dev Sandbox',
            labelMobile: 'Dev Sandbox',
            className: "beta",
            icon: "flask"
        }
    }

    if (!badges?.length) return null

    return (
        <div className={`badge-container ${position ? `badge-container--${position}` : ''}`}>
            {badges.map((badge) => {
                const config = badgeConfig[badge]
                if (!config) return null

                const label = mode === 'mobile' || mode === 'tablet' ? config.labelMobile : config.labelDesktop

                return (
                    <span key={badge} className={`badge badge-${config.className}`}>
                        {config.icon && <Icon iconName={config.icon} />}
                        <span>{label}</span>
                    </span>
                )
            })}
        </div>
    )
}

export default Badge